var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowMoreModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6,6.6L13.6,6.6l-3.1,0c0,0,0,0,0,0c-0.5,0-0.9,0.4-0.9,0.9v0.7H9h0C8.5,8.1,8.1,8.5,8.1,9v0.7H7.4h0 c-0.5,0-0.9,0.4-0.9,0.9v6.1v0c0,0.5,0.4,0.9,0.9,0.9l6.1,0c0.5,0,0.9-0.4,0.9-0.9V16h0.7c0.5,0,0.9-0.4,0.9-0.9v-0.7h0.7 c0.5,0,0.9-0.4,0.9-0.9v-7H13.6z M9,9.7V9h0.7v0.7v0.9H9V9.7z M13.5,16.7H7.4l0-6.1h0.7v4.5v0C8.1,15.6,8.5,16,9,16h4.5V16.7z  M15.1,15.1H9l0-4.5h0.7v3v0c0,0.5,0.4,0.9,0.9,0.9h4.5V15.1z M16.7,13.6h-6.1V7.4h3.1v0h2.4l0.6,0.6V13.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreModal);
export default __webpack_public_path__ + "static/media/ShowMoreModal.4c29f674.svg";
export { ForwardRef as ReactComponent };